import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";

import {
  createDiseaseAPI,
  createGroupAPI,
  createPackageAPI,
  deleteLabCategory,
  deletePackageAPI,
  deleteTestCategory,
  getPackageAPIList,
  getPackageListAPI,
  listDiseaseAPI,
  listGroupAPI,
  updateDiseaseAPI,
  updateGroupAPI,
  updatePackageAPI,
} from "../../api/master/indes";

import MyInput from "../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import { categoryTestDDAPI, generateFileAPI, subCategoryDDAPI, subMultipleCategoryDDAPI } from "../../api/dropdown";
import MyCreateSelect from "../../MyComp/UI/form/MyCreateSelect";
import MySelect from "../../MyComp/UI/form/MySelect";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import DiscountValidation from "../../MyComp/UI/form/DiscountValidation";

const Package = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // Table Columns
  const [column, setColumn] = useState([
    {
      name: "Image",
      selector: (row) => (
        <div>
          {/* <img
            style={{ width: "50px", height: "50px", borderRadius: "6px" }}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
          /> */}
          <UserAvatarCell
            row={row}
            name={row?.package_name}
            handleImageOpenPreview={handleImageOpenPreview}
            image={`${BASE_URL_IMG}${row.image}`}
          />
        </div>
      ),
      sortable: false,
      wrap: true,
    },
    // {
    //   name: "Name",
    //   selector: (row) => row?.package_name,
    //   sortable: true,
    // },
      {
      name: "Name",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = row?.package_name || "";

        return (
          <div
            title={fullAddress}   // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullAddress, 20)}
          </div>
        );
      },
    },
    
    // {
    //   name: "Description",
    //   selector: (row) => row?.package_description,
    //   sortable: true,
    // },
    
 
       {
      name: "Price",
      selector: (row) => row?.package_price,
      sortable: true,
    },
       {
      name: "Discount",
      selector: (row) => row?.discount,
      sortable: true,
    },
    {
      name: "Net",
      selector: (row) => row?.Net,
      sortable: true,
      wrap: false,
      // cell: (row) => {
      //   const fullAddress = row?.package_description || "";

      //   return (
      //     <div
      //       title={fullAddress}   // full text on hover
      //       style={{
      //         maxWidth: "150px",
      //         overflow: "hidden",
      //         cursor: "pointer",
      //       }}
      //     >
      //       {truncateByCharacters(fullAddress, 20)}
      //     </div>
      //   );
      // },
    },
 
    {
      name: "Description",
      selector: (row) => row?.package_description,
      sortable: true,
    },

    //  {
    //   name: "Package Details",
    //   selector: (row) => row?.details,
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);

  // Fetch group list

  useEffect(() => {
    // if (watch("categoryDD")?.length < 1) {
    //   getCategory();
    // }
    getPackageList();
  }, []);

  const getPackageList = (pageNum = page, limitNum = limit) => {
    setLoading(true);
    getPackageAPIList({ page: pageNum, limit: limitNum })
      .then((res) => {
        if (res.data.status === true) {
          setValue("data", res.data.data);
          setLoading(false);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
          setLoading(false);
        } else {
          toast.error(res.data.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const onFormSubmit = async (data) => {
    try {
      // setIsLoading(true);
      setValue("isLoading", true);
      const formData = new FormData();

      // Debug
      console.log("Submitting...");

      // Status
      const status = watch("status");
      if (status?.value) {
        formData.append("status", status.value);
      }

      // Image
      // const imgFile = watch("package_image");
      // if (imgFile instanceof File) {
      //   formData.append("package_image", imgFile);
      // }
      const imgFile = watch("package_img");
      if (imgFile) {
        formData.append("image", imgFile);
      }
      // Name & Price
      formData.append("name", watch("name"));
      formData.append("Net", watch("net"));
      formData.append("price", watch("price"));
      formData.append("discountType", data?.discount_type?.value);
      formData.append("package_description", watch("package_description"));
      formData.append("discount", watch("discount"));

      // Description
      // const desc = watch("package_description");
      // if (Array.isArray(desc)) {
      //   formData.append("package_description", JSON.stringify(desc.map((d) => d.label)));
      // }

      // Edit mode
      if (mode === "Edit") {
        formData.append("id", watch("selectedRow")?.id);
      }

      // Debug FormData
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const res = mode === "Add" ? await createPackageAPI(formData) : await updatePackageAPI(formData);

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        setPage(1); // Reset to page 1 to see updated data
        await getPackageList(1, limit);
        resetF();

        setIsOpen(false);
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      // setIsLoading(false);
      setValue("isLoading", false);
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("name", row?.package_name);
    setValue("package-detail", row?.details);
    setValue("discount", row?.discount);
    setValue("Net", row?.Net);
    // setValue("discount_type", row?.discount_type);
    setValue("start_date", new Date(row.startDate));
    setValue("exp_date", new Date(row.endDate));
    setValue("discount_type", { label: row.discount_type, value: row.discount_type });
    setValue(
      "discount_type",
      [
        { value: "percentage", label: "percentage" },
        { value: "fixed", label: "fixed" },
      ].find((item) => item?.value == row?.discount_type),
    );
    setValue("package_image", `${BASE_URL_IMG}${row?.image}`); // preview URL
    setValue("package_img", null);
    setValue("value", row.discountValue);
    // setValue("description", row.package_description ? row.package_description.map((desc) => ({ label: desc, value: desc })) : []);
    // setValue("description", [{label:row.package_description.label,value:row.package_description.value}].find((item) => item?.value == row?.package_description?.value));
    setValue("code", row.code);
    // setValue("description", {label:row.package_description,value:row.package_description});
    setValue(
      "package_description",
      row.package_description.split(",").map((item) => ({
        label: item.trim(),
        value: item.trim(),
      })),
    );

    setValue("discount", row.discountValue);
    setValue("price", row.package_price);
    setValue("max_discount", row.maximum_discount_amount);
    setValue("order", row.order);
    setValue("Net", row.Net);
    setValue("discount", row.discount);
    setValue("package_description", row.package_description);
    setValue(
      "discountType",
      [
        { value: "percentage", label: "percentage" },
        { value: "fixed", label: "fixed" },
      ].find((item) => item.value === row?.discountType) || null,
    );

    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  console.log(errors, "errors");
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    // setValue("isLoading", true);
    const formObject = {
      //   id: watch("selectedRow").id,
      //api not available for status change in group using id
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getPackageList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const [loading, setLoading] = useState(false);
  const resetF = () => {
    setValue("package_image", null);
    setValue("package_description", "");
    setValue("name", "");
    setValue("status", null);
    setValue("category", null);
    setValue("subCategory", null);
    setValue("discount_type", null);
    setValue("discount", null);
    setValue("net", null);
    // setValue("", null);

    // setValue("type", null);
    setValue("image_preview", null);
    setValue("package-detail", null);
    setValue("price", null);
    setValue("package_img", null);
        clearErrors()
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    deletePackageAPI({ id: watch("selectedRow").id })
      .then((res) => {
        // setLoading(false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setPage(1); // Reset to page 1 after deletion
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
          getPackageList(1, limit);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(()=>{
    getSubCategory();
  },[])
  useEffect(() => {
    const categories = watch("category"); // array of selected categories

    if (Array.isArray(categories) && categories.length > 0) {
      // Extract all selected IDs
      const categoryIds = categories.map((cat) => cat.value);
      getSubCategory(categoryIds);
    } else {
      setValue("subCategoryDD", []);
    }
  }, [watch("category")]);
  useEffect(()=>{
    getSubCategory();
  },[mode])

  const getSubCategory = (categoryIds) => {
    const body = { categoryIds };

    subMultipleCategoryDDAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const options = res.data.data.map((item) => ({
            value: item.value,
            label: item.label,
          }));

          setValue("subCategoryDD", options);
        } else if (res.data.status === "expired") {
          logout();
        } else {
          setValue("subCategoryDD", []);
        }
      })
      .catch(() => {
        setValue("subCategoryDD", []);
      });
  };
  const generateFile = () => {
    // const body = { categoryId };

    generateFileAPI()
      .then((res) => {
        console.log(res.data, "res.fileee");
        if (res.data.status === true) {
          // setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          // setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };


  useEffect(() => {
    const price = watch("price");
    const discount = watch("discount");
    const discountType = watch("discount_type");

    if (price && discount && discountType) {
      let netPrice = parseFloat(price);
      const discountValue = parseFloat(discount);

      if (discountType.value === "percentage") {
        netPrice = price - price * (discountValue / 100);
      } else if (discountType.value === "fixed") {
        netPrice = price - discountValue;
      }



      netPrice = Math.max(0, netPrice);

      setValue("net", netPrice.toFixed(2));

      trigger("net");
    } else {
      setValue("net", "");
    }
  }, [watch("price"), watch("discount"), watch("discount_type")]);
  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";

    return text.length > charLimit
      ? text.slice(0, charLimit) + "..."
      : text;
  };
  return (
    <>
      <Head title="Group | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Package
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent className={"me-2"}>
              <div className="me-2 d-flex g-5 mt-2">
                {/* <Button
                  color="primary"
                  outline
                  className="me-n1 me-2 pe-2"
                  onClick={() => {
                    generateFile();
                    resetF();
                  }}
                >
                  <Icon name={"file"} />
                </Button> */}
                <Button
                  color="primary"
                  outline
                  className="me-n1  mx-2"
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Name"
                      name="name"
                      placeholder="Enter Name"
                      required
                    />
                  </Col>

                  {/* <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Group"}
                      name={"category"}
                      placeholder={"Select Group"}
                      // required
                      options={watch("categoryDD")}
                      multi
                    />
                  </Col> */}

                  {/* <Col md="4" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Sub Group"}
                      name={"description"}
                      // onClick={gets}
                      placeholder={"Select Sub Group"}
                      required
                      options={watch("subCategoryDD")}
                      multi
                    />
                  </Col> */}
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Price"
                      name="price"
                      placeholder="Enter price"
                      required
                      min={0.01}
                      validation={{
                        validate: (value) => {
                          if (value <= 0) return "Price must be greater than 0";
                          return true;
                        },
                      }}
                    />
                  </Col>

                  <Col md={4}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Type"}
                      name={"discount_type"}
                      placeholder={"Select type"}
                      required
                      options={[
                        { value: "percentage", label: "percentage" },
                        { value: "fixed", label: "fixed" },
                      ]}
                    />
                  </Col>

                  <Col md="4" className={``}>
                    <DiscountValidation
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Discount"}
                      name={"discount"}
                      placeholder={"Enter discount"}
                      required
                      minNum={0} 
                     
                      validate={(value) => {
                        const type = watch("discount_type")?.value;
                        const price = watch("price");

                        if (!value) return true; 

                        const discountValue = parseFloat(value);
                        const priceValue = parseFloat(price);

                        if (isNaN(discountValue)) return "Please enter a valid number";

                        if (!price || isNaN(priceValue) || priceValue <= 0) {
                          return "Please enter a valid price first";
                        }

                        if (type === "percentage") {
                          if (discountValue < 0) return "Percentage cannot be negative";
                          if (discountValue > 100) return "Percentage cannot exceed 100%";

                          // Calculate actual discount amount
                          const discountAmount = (priceValue * discountValue) / 100;
                          if (discountAmount >= priceValue) {
                            return "Discount amount must be less than price";
                          }
                        } else if (type === "fixed") {
                          if (discountValue < 0) return "Discount cannot be negative";
                          if (discountValue >= priceValue) {
                            return "Fixed discount must be less than price";
                          }
                        } else {
                          return "Please select a discount type first";
                        }

                        return true;
                      }}
                    />
                  </Col>
                  <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Net"}
                      name={"net"}
                      placeholder={"Auto-calculated"}
                      readOnly
                      disabled
                    />
                  </Col>

                  {/* <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Minimum Amount"}
                      name={"min_amount"}
                      placeholder={"Enter minimum amount to avail coupon"}
                      required
                      min={1}
                      max={3}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Maximum Discount"}
                      name={"max_discount"}
                      placeholder={"Enter maximum discount to avail"}
                      required
                      min={1} 
                    />
                  </Col> */}
                  {/* <Col md="2" className={``}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Start Date"}
                      name={"start_date"}
                      placeholder={"Enter start date"}
                      required
                      min={moment().add(0, "days").toDate()}
                      max={moment().add(1, "years").toDate()}
                      time
                      format={"MM/dd/yyyy h:mm aa"}
                    />
                  </Col> */}
                  {/* <Col md="2" className={``}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Expiry Date"}
                      name={"exp_date"}
                      placeholder={"Enter expiry date"}
                      required
                      min={moment().add(1, "days").toDate()}
                      max={moment().add(1, "years").toDate()}
                      time
                      format={"MM/dd/yyyy h:mm aa"}
                    />
                  </Col> */}

                  {/* <Col md="2" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Select category"}
                      required
                      options={watch("categoryDD")}
                      multi
                    />
                  </Col> */}

                  <Col md="4" className="">
                    <ImageUpload
                      name="package_image"
                      id="package_image"
                      watch={watch}
                      label="Upload Package Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="package_img"
                      setError={setError}
                      image_url="package_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Pacakge Details"
                      name="package-detail"
                      placeholder="Enter package details"
                      required
                    />
                  </Col> */}
                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Description"
                      name="package_description"
                      placeholder="Enter description"
                      required
                    />
                  </Col>

                  <Col md="4" className="">
                    <Status
                      register={register}
                      watch={watch}
                      // name={"status"}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      required
                    />
                  </Col>
                </Row>{" "}
                <Col md="3">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title="Package List" isLoading={isLoading} generateFile={generateFile} resetF={resetF}/>
        </Block>
      </Content>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={isLoading}
      />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />

      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default Package;
